import * as React from "react";
import { FormControlProps } from "./types";
import { useData, useDataValue } from "../hooks/useData";

export function Static(props: FormControlProps & {

}) {
    const data = useData();
	let value = useDataValue(data, props.prop);

    const {
        className,
        placeholder,
    } = props;

	return (
		<div className={"flex group align-start " + className}>
			{value ? value : placeholder}
		</div>
	);

}

